export default __webpack_public_path__ + "static/media/fail-sign.1f89a255.png";